import { Label } from '@playcastdotio/Shadcn';

export const Content = ({ title, children }: { title: string; children: React.ReactNode }) => {
  return (
    <div data-testid='content-root' className='flex flex-1 flex-col gap-6 text-white'>
      <Label className='font-[Syne] text-3xl'>{title}</Label>
      <div data-testid='content-children-container' className='flex h-full w-full'>
        {children}
      </div>
    </div>
  );
};
